import { findAllComponentsSpecByType, findAllShades, COMPONENT_TYPE } from "@/plano/utils";
import categories from "@/services/categories";
import { mapState } from "vuex";

export default {
    props: {
        plano: {
            type: Object
        }
    },
    methods: {
        count(array) {
            return array && array.length;
        },
        sku(array) {
            return this.count([...new Set(array)]);
        }
    },
    computed: {
        ...mapState("planoStats", ["categories", "moduleDetails"]),
        config() {
            return this.plano && this.plano.config;
        },
        allShades() {
            return findAllShades(this.config);
        },
        allModules() {
            return findAllComponentsSpecByType(this.config, [COMPONENT_TYPE.module]).map(module => module.model);
        },
        allShelves() {
            return findAllComponentsSpecByType(this.config, [COMPONENT_TYPE.shelf]).map(module => module.model);
        },
        allCaddy() {
            return findAllComponentsSpecByType(this.config, [COMPONENT_TYPE.caddy]).map(module => module.model);
        },
        sortedCategories() {
            let allModules = findAllComponentsSpecByType(this.config, [COMPONENT_TYPE.module]);
            let listCategoriesForPercentage = [];
            for (let module of allModules) {
                const moduleDetail = this.moduleDetails.find(m => m && m.id === module.model.id);
                if (moduleDetail) {
                    let moduleCategories = Object.keys(moduleDetail.infoCategories.categories);
                    listCategoriesForPercentage.push(parseInt(...moduleCategories));
                }
            }
            let categoriesToDisplay = [];
            for (let category of this.categories) {
                let categoryListInConfig = listCategoriesForPercentage.filter(categoryId => categoryId === category.id);
                let percentage = categoryListInConfig.length / listCategoriesForPercentage.length;
                categoriesToDisplay.push({ ...category, percentage });
            }
            return categoriesToDisplay
                .filter(category => category.percentage > 0)
                .sort((a, b) => b.percentage - a.percentage)
                .slice(0, 4);
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/PlanoStatsMixin.js